import { render } from "./PageNotFoundView.vue?vue&type=template&id=28a36901&scoped=true"
const script = {}

import "./PageNotFoundView.vue?vue&type=style&index=0&id=28a36901&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a36901"]])

export default __exports__